import React, {useEffect, useState} from 'react';
import {EntryTimelineItem} from './EntryTimelineItem';
import {EntryTimelineComment} from './EntryTimelineComment';
import {Tooltip} from './Tooltip';

type EntryTimelineProps = {
    timeline: TimelineItem[];
};

export type TimelineItem = {
    date_created: string;
    date_created_iso8601: string;
    id: string;
    user_id: string;
    user_name: string;
    value: string;
    note_type?: string;
    user_email?: string;
    avatar: string;
    display_name: string;
    step_type?: string;
    hasUserComment: boolean;
    isWorkflowComment: boolean;
};

export const EntryTimeline: React.FunctionComponent<EntryTimelineProps> = ({
                                                                               timeline = []
                                                                           }): JSX.Element => {
    const [showOnlyComments, setShowOnlyComments] = useState<boolean>(false);
    const [showNotifications, setShowNotifications] = useState<boolean>(false);
    const [selectedFeed, setSelectedFeed] = useState<'timeline' | 'comments'>('comments');

    const comments = timeline.filter((item: TimelineItem) => item.hasUserComment);
    useEffect(() => {
        console.log('comments', comments);
        if (comments.length === 0) {
            setSelectedFeed('timeline');
        }
    }, []);

    return (
        <div id="entry-timeline">
            <div id="postbox-container-2" className="timeline-container">
                <div className="gravityflow-timeline">
                    <div className="d-flex justify-content-between align-items-end mb-1">
                        <div className="d-flex">
                            <h3 className={'m-0 timeline-title ' + (selectedFeed === 'timeline' ? 'text-muted' : 'active')}
                                onClick={() => setSelectedFeed('comments')}
                                style={{cursor: 'pointer'}}
                            >Comments({comments.length})</h3>
                            <h3 className="m-0 ml-2 mr-2">|</h3>
                            <h3 className={'m-0 timeline-title ' + (selectedFeed === 'comments' ? 'text-muted' : 'active')}
                                onClick={() => setSelectedFeed('timeline')}
                                style={{cursor: 'pointer'}}
                            >Timeline</h3>
                        </div>
                        {selectedFeed === 'timeline' &&
                            <div>
                                <div className="form-check">
                                    <input type="checkbox"
                                           className="form-check-input"
                                           id="show-only-comments"
                                           onChange={(e) => {
                                               setShowOnlyComments(e.target.checked);
                                           }}
                                    />
                                    <label className="form-check-label"
                                           htmlFor="show-only-comments">
                                        Show only Comments
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input type="checkbox"
                                           className="form-check-input"
                                           id="show-notifications"
                                           onChange={(e) => {
                                               setShowNotifications(e.target.checked);
                                           }}
                                    />
                                    <label className="form-check-label"
                                           htmlFor="show-notifications">
                                        Show Notifications
                                        <Tooltip text="Notifications prior to July 23 2023 are not shown">
                                            <a href="#" className="flow-help" title="Help"><i className="fas fa-question-circle"/></a>
                                        </Tooltip>
                                    </label>
                                </div>
                            </div>
                        }
                    </div>

                    <div className=" inside mb-3">
                        {timeline
                            .filter((item: TimelineItem) => selectedFeed === 'timeline' || (selectedFeed === 'comments' && item.hasUserComment))
                            .filter((item: TimelineItem) => !showOnlyComments || (showOnlyComments && item.hasUserComment))
                            .filter((item: TimelineItem) => item.note_type !== 'entry-notification' || showNotifications && item.note_type === 'entry-notification')
                            .map((item: TimelineItem) => (
                                selectedFeed === 'comments' ?
                                    <EntryTimelineComment key={item.id} timelineItem={item}/>
                                    :
                                    <EntryTimelineItem key={item.id} timelineItem={item}/>
                            ))}

                        {selectedFeed === 'comments' && comments.length === 0 &&
                            <p className="p-3"><em>No comments have been added yet</em></p>
                        }

                        {selectedFeed === 'comments' && comments.length > 0 &&
                            <button type="button"
                                    className="btn btn-block btn-lg btn-outline-secondary mt-3"
                                    onClick={() => setSelectedFeed('timeline')}
                            >View Complete Timeline</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}